import React from "react";
import { TextField, ActionButton, ErrorText } from "../../atoms";
import T from "prop-types";
import { FaEye, FaEyeSlash } from "react-icons/fa";
{/*@TCS_START@*/ }
const userEmail = localStorage.getItem("userEmail");
export const ResetPasswordForm = ({
  ResetPasswordAction, 
  onChangeNewPassword,
  onChangeConfirmPassword,  
  errorMessage, 
  newPassword,
  confirmNewPassword,
  isSubmit,
  toggleNewPassword,
  toggleConfirmNewPassword, 
  isNewPassVisible,
  isConfirmNewPassVisible,
  isLoading,
}) => (
  <>
    <form onSubmit={ResetPasswordAction}>
      
      <div className="passwordLogin">
        <TextField
          placeholder="New Password"
          mainWrapCls={"loginWrapCls"}
          icon={
            isNewPassVisible ? (
              <FaEye className="textfield-icon" onClick={toggleNewPassword} />
            ) : (
              <FaEyeSlash className="textfield-icon" onClick={toggleNewPassword} />
            )
          }
          type={isNewPassVisible ? "password" : "text"}
          isNewPassVisible={isNewPassVisible}
          toggleNewPassword={toggleNewPassword}
          onChange={(e) => onChangeNewPassword(e)}
          isError={newPassword === "" && isSubmit ? true : false}
          errorText={
            newPassword === "" && isSubmit ? "Please enter new password" : null
          }
        />
      </div>
      <div className="passwordLogin">
        <TextField
          placeholder="Confirm New Password"
          mainWrapCls={"loginWrapCls"}
          icon={
            isConfirmNewPassVisible ? (
              <FaEye className="textfield-icon" onClick={toggleConfirmNewPassword} />
            ) : (
              <FaEyeSlash className="textfield-icon" onClick={toggleConfirmNewPassword} />
            )
          }
          type={isConfirmNewPassVisible ? "password" : "text"}
          isConfirmNewPassVisible={isConfirmNewPassVisible}
          toggleConfirmNewPassword={toggleConfirmNewPassword}
          onChange={(e) => onChangeConfirmPassword(e)}
          isError={(confirmNewPassword === "" && isSubmit) || (confirmNewPassword !== newPassword && isSubmit) ? true : false}
          errorText={
            (confirmNewPassword === "" && isSubmit) || (confirmNewPassword !== newPassword && isSubmit) ? "Please confirm your new password, passwords entered dont match" : null
          }
        />
      </div>
      
      {isSubmit && errorMessage !== "" && newPassword !== "" ? (
        <div className="errorTexttwrap">
          <ErrorText text={errorMessage} />
        </div>
      ) : null}
      <div className="btnSec">
        <ActionButton text="Reset Password" isLoading={isLoading} type={"submit"} />
      </div>
    </form>
  </>
);
{/*@TCS_END@*/ }
ResetPasswordForm.T = {
  onClick: T.func,
};

ResetPasswordForm.defaultProps = {
  onClick: null,
};
